import http from '../../axios-config/g-http-metodos';
function excluirGrupoById(GrupoId) {
  const { res, erro, requisicao } = http.post(`Grupos/ExcluiGrupoById/${GrupoId}`)
  return { GrupoArray: res , erro, requisicao }
}
function getGruposAtivos() {
  const { res, erro, requisicao } = http.get('Grupos/GetGruposAtivos')
  return { GrupoArray: res , erro, requisicao }
}
function getUsuariosLideres() {
  const { res, erro, requisicao } = http.get('Grupos/GetUsuariosLideres')
  return { GrupoArray: res , erro, requisicao }
}
function getGrupoByFiltro(grupoViewModel) {
  const { res, erro, requisicao } = http.postArray("Grupos/GetGrupoByFiltro", grupoViewModel)
  return { GrupoArray: res , erro, requisicao }
}

function GetUsuariosVinculadosAoGrupoById(GrupoId) {
  const { res, erro, requisicao } = http.getArray(`Grupos/GetUsuariosVinculadosAoGrupoById/${GrupoId}`)
  return { GrupoArray: res , erro, requisicao }
}

function VerificaQuantidadeGrupoPorUsuario(UsuarioId) {
  const { res, erro, requisicao } = http.getArray(`Grupos/VerificaQuantidadeGrupoPorUsuario/${UsuarioId}`)
  return { GrupoArray: res , erro, requisicao }
}
const GrupoController = {
    VerificaQuantidadeGrupoPorUsuario,
    excluirGrupoById,
    getGruposAtivos,
    getGrupoByFiltro,
    getUsuariosLideres,
    GetUsuariosVinculadosAoGrupoById
}

export default GrupoController
